import {
  Create,
  ListButton,
  required,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  TopToolbar,
} from "react-admin";

import { MODULE_NAMES } from "@/constants/modules";
import { DOMAIN_VALIDATION_REGEXP } from "@/constants/validation";
import { ReferenceSelectInput } from "@/inputs/ReferenceSelectInput";
import { regexValidator } from "@/utils";

const CreateToolbar = () => (
  <Toolbar sx={{ gap: 2 }}>
    <SaveButton label="Create" />
    <ListButton label="Cancel" icon={null} variant="outlined" size="medium" />
  </Toolbar>
);

const CreateActions = () => (
  <TopToolbar sx={{ justifyContent: "flex-start" }}>
    <ListButton />
  </TopToolbar>
);

export const LandingDomainCreate = () => (
  <Create actions={<CreateActions />} redirect="list">
    <SimpleForm toolbar={<CreateToolbar />}>
      <TextInput
        type="string"
        source="url"
        validate={[
          required(),
          regexValidator(DOMAIN_VALIDATION_REGEXP, "Invalid domain format"),
        ]}
      />
      <ReferenceSelectInput
        module={MODULE_NAMES.LANDING_REGIONS}
        source="region"
        optionText="name"
        optionValue="@id"
        validate={[required()]}
      />
    </SimpleForm>
  </Create>
);
